import AccountService from '@/services/AccountService.js'
import ClientService from '@/services/ClientService'
import CebelcaService from '@/services/CebelcaService'

export const state = {
  clients: [],
  client: {} 
}

export const mutations = {
  ADD_CLIENT(state, client) {
    state.clients.push(client)
  },
  DELETE_CLIENT(state, client) {
    state.clients = state.clients.filter(t => t.id != client.id)
  },
  EDIT_CLIENT(state, client) {
    state.client = client
  },
  SET_CLIENTS(state, clients) {
    state.clients = clients
  },
  SET_CLIENT(state, client) {
    state.client = client
  }
}

export const namespaced = true //all mutations, actions, getters will be namespaced under "Product"//

export const actions = {
  createClient({ commit, dispatch }, client) {
    return AccountService.postClient(client)
      .then(() => {
        commit('ADD_CLIENT', client)
        const notification = {
          type: 'success',
          message: 'New client has been created!'
        }
        dispatch('notification/add', notification, { root: true })
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem creating new client: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  fetchClients({ commit, dispatch }) {
    AccountService.getClients()
      .then(response => {
        commit('SET_CLIENTS', response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching clients: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  fetchClient({ commit, getters }, id) {
    var client = getters.getClientById(id)

    if (client) {
      commit('SET_CLIENT', client)
      return client
    } else {
      return AccountService.getClient(id) // <-- Send the prop id to our ProductService//
        .then(response => {
          commit('SET_CLIENT', response.data)
          return response.data
        })
    }
  },
  removeClient({ commit }, client) {
    AccountService.deleteClient(client)
    commit('DELETE_CLIENT', client)
  },
  editClient({ commit }, client) {
    AccountService.updateClient(client)
    commit('EDIT_CLIENT', client)
  },
  addClient({ commit, dispatch }, client) {
    return AccountService.addClient(client)
      .then(() => {
        commit('ADD_CLIENT', client)
        const notification = {
          type: 'success',
          message: 'Details saved successfully!'
        }
        dispatch('notification/add', notification, { root: true })
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching clients: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  profileCompleteness({ dispatch }) {
    return AccountService.profileCompleteness()
      .then((response) => {
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem checking client profile completeness: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  fetchClientActiveDetail({ dispatch }) {
    return ClientService.getClientActiveDetail()
      .then(response => {
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching client details: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  addPresetcategoriesForClient({ dispatch }, caountryJson) {
    return ClientService.addPresetcategoriesForClient(caountryJson)
      .then(() => {
        const notification = {
          type: 'success',
          message: 'Details saved successfully!'
        }
        dispatch('notification/add', notification, { root: true })
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem adding details: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  createCebelcaAccount({ dispatch }, body) {
    return CebelcaService.signUpInCebelca(body)
      .then((response) => {
        return response.data
      })
      .catch(error => {
        alert(error)
        const notification = {
          type: 'error',
          message: 'There was a problem while adding cebelca account: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  connectCebelcaAccount({ dispatch }, body) {
    return CebelcaService.connectCebelcaAccount(body)
      .then((response) => {
        return response.data
      })
      .catch(error => {
        alert(error)
        const notification = {
          type: 'error',
          message: 'There was a problem while connecting cebelca account: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  checkFiscalisationCertUploaded({ dispatch }) {
    return new Promise((resolve, reject) => {
      CebelcaService.checkFiscalisationCertUploaded()
        .then((response) => {
          return resolve(response.data)
        })
        .catch(error => {
          alert(error)
          const notification = {
            type: 'error',
            message: 'There was a problem while checking cebelca certificate uploaded or not: ' + error.message
          }
          dispatch('notification/add', notification, { root: true })
          return reject(error)
        })
    })
  },
  fetchCascadianCityList({ dispatch }, lang) {
    return ClientService.fetchCascadianCityList(lang)
      .then(response => {
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching cascadian city: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  fetchCascadianRegion({ dispatch }, cityJson) {
    return ClientService.fetchCascadianRegion(cityJson)
      .then(response => {
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching cascadian region: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  sendRestockRejectionMailToClient({ dispatch }, mailBody) {
    return ClientService.sendRestockRejectionMailToClient(mailBody)
      .then(response => {
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem sending restock mail to client: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  }
}

export const getters = {
  getClientById: state => id => {
    return state.clients.find(client => client.id === id)
  }
}
